import React, { useState } from "react";
import { req } from "../api";
import { useNavigate } from "react-router-dom";

export default function Login({ onAuthed }) {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const r = await req("/api/auth/login", { method: "POST", body: { email, password } });
      if (!r.json?.ok) throw new Error(r.json?.error || "Login failed");

      if (typeof onAuthed === "function") {
        await onAuthed(); // обновляем me в Shell без перезагрузки
      }

      nav("/payments", { replace: true });
    } catch (e2) {
      setErr(String(e2.message || e2));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ maxWidth: 520, margin: "40px auto", padding: 16 }}>
      <h2>Poteme Pay — Login</h2>
      {err ? <div style={{ color: "crimson", marginBottom: 10 }}>{err}</div> : null}
      <form onSubmit={submit} style={{ display: "grid", gap: 10 }}>
        <label>
          Email
          <input value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label>
          Password
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <button disabled={loading} type="submit">
          {loading ? "..." : "Login"}
        </button>
      </form>
    </div>
  );
}
